import { c as _c } from "react/compiler-runtime";
import React, { use, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import notFoundNewConsumerApp from 'commons/notFoundNewConsumerApp';
import PDPDesktop from './PDPDesktop';
import PDPMobile from './PDPMobile';
import Component404 from '../404';
import MobileAndTabletOnly from '../MobileAndTabletOnly';
import DesktopOnly from '../DesktopOnly';
import PDPSEOTags from './PDPSEOTags';
import PDPFooter from './PDPFooter';
import PDPContext from './state/context/PDPContext';
import usePDPLuxAnalytics from './hooks/usePDPLuxAnalytics';
import usePDPCreateContextValue from './hooks/usePDPCreateContextValue';
import PDPPageAnalytics from './PDPPageAnalytics';
import SuspenseWithLoader from '../SuspenseWithLoader';
import PDPPlaceholder from './PDPPlaceholder';
import buildPdpDesktopHeroLcpUrl from './PDPDesktopHeroGallery/helpers/buildPdpDesktopHeroLcpUrl';
const PDPInner = t0 => {
  const $ = _c(45);
  const {
    slugOverride: t1,
    isEditOrder: t2,
    pdpIsModularBYOProduct: t3,
    productOptionsPromise,
    productHeroImagePromise,
    productCylindoHeroImagePromise
  } = t0;
  const slugOverride = t1 === undefined ? null : t1;
  const isEditOrder = t2 === undefined ? false : t2;
  const pdpIsModularBYOProduct = t3 === undefined ? false : t3;
  const params = useParams();
  const slug = slugOverride ?? params.slug ?? null;
  const productOptions = productOptionsPromise ? use(productOptionsPromise) : null;
  const productHeroImageFromServer = productHeroImagePromise ? use(productHeroImagePromise) : null;
  const productCylindoHeroImage = productCylindoHeroImagePromise ? use(productCylindoHeroImagePromise) : null;
  let t4;
  if ($[0] !== isEditOrder || $[1] !== pdpIsModularBYOProduct || $[2] !== productOptions || $[3] !== slug) {
    t4 = {
      isEditOrder,
      pdpIsModularBYOProduct,
      slug,
      productOptions
    };
    $[0] = isEditOrder;
    $[1] = pdpIsModularBYOProduct;
    $[2] = productOptions;
    $[3] = slug;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const pdpContextValue = usePDPCreateContextValue(t4);
  usePDPLuxAnalytics();
  let t5;
  bb0: {
    if (productHeroImageFromServer?.src) {
      t5 = productHeroImageFromServer;
      break bb0;
    }
    const heroUrl = pdpContextValue.basicDetails?.data?.hero_images?.[0]?.img?.url;
    if (!heroUrl) {
      t5 = null;
      break bb0;
    }
    const t6 = pdpContextValue.basicDetails?.data?.name ? String(pdpContextValue.basicDetails.data.name) : "";
    let t7;
    if ($[5] !== heroUrl || $[6] !== t6) {
      t7 = {
        src: heroUrl,
        width: 1600,
        height: 2400,
        alt: t6
      };
      $[5] = heroUrl;
      $[6] = t6;
      $[7] = t7;
    } else {
      t7 = $[7];
    }
    t5 = t7;
  }
  const productHeroImage = t5;
  if (pdpContextValue.basicDetails.isProductNotFound) {
    if (!isNewConsumerApp) {
      let t6;
      if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = <Component404 />;
        $[8] = t6;
      } else {
        t6 = $[8];
      }
      return t6;
    }
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = notFoundNewConsumerApp();
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    return t6;
  }
  let t6;
  if ($[10] !== pdpContextValue.stockAvailability?.data) {
    t6 = pdpContextValue.stockAvailability?.data || {};
    $[10] = pdpContextValue.stockAvailability?.data;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const {
    discontinuedCategoryMsg: t7,
    isDiscontinued: t8,
    isEFGInternal,
    isOutOfStock: t9,
    showNotification
  } = t6;
  const discontinuedCategoryMsg = t7 === undefined ? null : t7;
  const isDiscontinued = t8 === undefined ? false : t8;
  const isOutOfStock = t9 === undefined ? false : t9;
  let t10;
  if ($[12] !== productHeroImage) {
    t10 = productHeroImage?.src ? buildPdpDesktopHeroLcpUrl(productHeroImage.src) ?? productHeroImage.src : null;
    $[12] = productHeroImage;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const heroPreloadHref = t10;
  let t11;
  if ($[14] !== heroPreloadHref) {
    t11 = heroPreloadHref ? <Helmet><link rel="preload" as="image" href={heroPreloadHref} media="(min-width: 1024px)" fetchPriority="high" /></Helmet> : null;
    $[14] = heroPreloadHref;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== isOutOfStock) {
    t12 = <PDPSEOTags isOutOfStock={isOutOfStock} />;
    $[16] = isOutOfStock;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  const t13 = isDiscontinued ? discontinuedCategoryMsg : null;
  let t14;
  if ($[18] !== isDiscontinued || $[19] !== isEditOrder || $[20] !== isOutOfStock || $[21] !== pdpIsModularBYOProduct || $[22] !== showNotification || $[23] !== slug || $[24] !== t13) {
    t14 = <MobileAndTabletOnly><PDPMobile slug={slug} isEditOrder={isEditOrder} isOutOfStock={isOutOfStock} showOutOfStockNotification={showNotification} pdpIsModularBYOProduct={pdpIsModularBYOProduct} showDiscontinuedNotification={isDiscontinued} discontinuedCategoryMsg={t13} /></MobileAndTabletOnly>;
    $[18] = isDiscontinued;
    $[19] = isEditOrder;
    $[20] = isOutOfStock;
    $[21] = pdpIsModularBYOProduct;
    $[22] = showNotification;
    $[23] = slug;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  const t15 = isDiscontinued ? discontinuedCategoryMsg : null;
  let t16;
  if ($[26] !== isDiscontinued || $[27] !== isEFGInternal || $[28] !== isEditOrder || $[29] !== isOutOfStock || $[30] !== pdpIsModularBYOProduct || $[31] !== productCylindoHeroImage || $[32] !== productHeroImage || $[33] !== showNotification || $[34] !== slug || $[35] !== t15) {
    t16 = <DesktopOnly><PDPDesktop slug={slug} isEditOrder={isEditOrder} isOutOfStock={isOutOfStock} showOutOfStockNotification={showNotification} pdpIsModularBYOProduct={pdpIsModularBYOProduct} isEFGInternal={isEFGInternal} showDiscontinuedNotification={isDiscontinued} discontinuedCategoryMsg={t15} productHeroImage={productHeroImage} productCylindoHeroImage={productCylindoHeroImage} /></DesktopOnly>;
    $[26] = isDiscontinued;
    $[27] = isEFGInternal;
    $[28] = isEditOrder;
    $[29] = isOutOfStock;
    $[30] = pdpIsModularBYOProduct;
    $[31] = productCylindoHeroImage;
    $[32] = productHeroImage;
    $[33] = showNotification;
    $[34] = slug;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  let t18;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <PDPPageAnalytics />;
    t18 = <PDPFooter />;
    $[37] = t17;
    $[38] = t18;
  } else {
    t17 = $[37];
    t18 = $[38];
  }
  let t19;
  if ($[39] !== pdpContextValue || $[40] !== t11 || $[41] !== t12 || $[42] !== t14 || $[43] !== t16) {
    t19 = <PDPContext.Provider value={pdpContextValue}>{t11}{t12}{t14}{t16}{t17}{t18}</PDPContext.Provider>;
    $[39] = pdpContextValue;
    $[40] = t11;
    $[41] = t12;
    $[42] = t14;
    $[43] = t16;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  return t19;
};
const PDP = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PDPPlaceholder />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
PDP.propTypes = {
  slugOverride: PropTypes.string,
  isEditOrder: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  productHeroImagePromise: PropTypes.object,
  productCylindoHeroImagePromise: PropTypes.object
};
export default PDP;